import { Json } from 'fp-ts/Json';
import * as C from 'io-ts/Codec';
import { JSON_RECORD } from 'src/modules/common/codecs/JsonValue';
import { ProjectSettings } from 'src/modules/common/types/ProjectSettings';

export const PROJECT_SETTINGS: C.Codec<unknown, Json, ProjectSettings> = JSON_RECORD;
